module.exports = __webpack_public_path__ + "img/arrow-down.75ba5010.svg";